import functions from '../functions';
import Slider from "../components/Slider";
import { list } from './list';
import { Select2 } from "../components/select2";

$(() => {
    listPackages.init();
});

const listPackages = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 10,
        language: functions.getLang(),
        pool: '',
        parking: '',
        pets: '',
        internet: '',
        dates: null,
        //dateFrom: null,
        //dateTo: null,
        destination: '',
        countryId: '',
        objectGroupId: 1,
        objectTypeId: '',
        guests: '',
        dynamicPackage: null,
        hasArrival: 3,
        //arrivalDateFrom: null,
        //arrivalDateTo: null,
        //aDateFrom: null,
        //aDateTo: null,
        tagCategoryId: null,
        tagCategoryIds: null,
        sortBy: null,
        objectName: '',
        unitServiceIds: '',
        hasDiscount: null,
        categoryObject: null,
        distanceBeach: null, 
        distanceCenter: null,
        placeFromId: null,
    },
    params: {},
    isHome: false,
    $listItems: null,
    triggerDepartureClearPoint: false,
    filterParams: {
        tagCategoryIds: null,
        categoryObject: null, 
        //sortBy: null, 
        objectName: null, 
        distanceBeach: null, 
        distanceCenter: null, 
        pool: null, 
        parking: null, 
        pets: null, 
        internet: null,
        objectTypeId: null,
        unitServiceIds: null,
        hasDiscount: null,
        //categoryObjectExact: 1,
    },
    mainFields: [
        'dateFrom', 
        'dateTo', 
        'destination', 
        //'objectTypeId', 
        'persons', 
        'personsInObject', 
        'sortBy', 
        '_page',
        'perPage',
        'language',
        'dynamicPackage',
        'hasArrival',
        'objectGroupId',
        'arrivalDateFrom',
        'arrivalDateTo',
        'departurePoint',
        'aDateFrom',
        'aDateTo',
        'placeFromId',
        'guests',
    ],
    init() {
        this.$form = $('.search-form.search-packages');
        this.form = this.$form[0];

        this.$filter = $('.search-filter');
        this.filter = this.$filter[0];

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;
        this.defaults.dynamicPackage = this.$form.attr('data-dynamicpackage');

        if(! this.form || this.defaults.objectGroupId != this.$form.attr('data-objectgroupid') || ! this.defaults.dynamicPackage) {
            return;
        }

        this.$filtersCount = $('.filters-count');

        //this.defaults.hasArrival = this.defaults.dynamicPackage ? 3 : null;
        this.defaults.countryId = this.$form.attr('data-countryid');
        this.defaults.destination = this.$form.attr('data-destination') ? this.$form.attr('data-destination') : this.defaults.countryId;
        this.defaults.tagCategoryId = this.$form.attr('data-tagcategoryid');
        this.filterParams.tagCategoryIds = this.$form.attr('data-tagcategoryids') || this.filterParams.tagCategoryIds;
        this.filterParams.hasDiscount = this.$form.attr('data-hasdiscount') || this.filterParams.hasDiscount;
        this.filterParams.objectTypeId = this.$form.attr('data-objecttypeid') || this.filterParams.objectTypeId

        if(! this.isHome) {
            this.getParams(); 
        }

        //list.$departurePoint = $("[name='departurePoint']:not('.set-on-mobile')");
        this.$departurePoint = $("[name='placeFromId']");

        this.$departurePoint.each((index, elem) => {
            const $elem = $(elem);

            let dynamicPackage = $elem.attr('data-dynamicPackage');
            let departures = [{key:-1, text: ''}];

            if (listPackages.params.placeFromId) {
                this.getDeparturePoints(dynamicPackage).then(response => {
                    let departurePoints = response || {};
                    departurePoints = departurePoints ? JSON.parse(departurePoints) : {};
                    departures = this.getDepartures(departurePoints);
                    this.initDeparturedSelect($elem, departures);
                    
                    $elem.val(listPackages.params.placeFromId).trigger('change', ['stop']);
                });
            }

            $elem.on('select2:opening', e => {

                const $target = $(e.currentTarget);

                ! $target.attr('data-loaded') &&  this.getDeparturePoints(dynamicPackage).then(response => {
                    let departurePoints = response || {};
                    departurePoints = departurePoints ? JSON.parse(departurePoints) : {};
                    departures = this.getDepartures(departurePoints);
                    this.initDeparturedSelect($elem, departures);
                    $target.select2('open');
                });

            });
            $elem.on('change', function (e, stop) {
                let letId = $elem.val();
                
                let departure = departures.filter(item => {
                    return item.id == letId;
                })[0] ?? null;
    
                $elem[0].departure = departure;

                let destination = $elem.parents('form').find('[name="destination"]').val().split(':');
                let hasDestination = false;

                if (destination[3] ?? null) {
                    hasDestination = departure?.data?.transfer_placeToIds.split(',').includes(destination[3]);
                } else if (destination[2] ?? null) {
                    hasDestination = departure?.data?.transfer_rivieraToIds.split(',').includes(destination[2]);
                } else if (destination[1] ?? null) {
                    hasDestination = departure?.data?.transfer_regionToIds.split(',').includes(destination[1]);
                } else if (destination[0] ?? null) {
                    hasDestination = departure?.data?.transfer_countryToIds.split(',').includes(destination[0]);
                }

                if (this.triggerDepartureClearPoint || ! hasDestination) {
                    $elem.parents('.search-form').find('.ms-clear').trigger('click');
                    listPackages.params = $.extend(listPackages.params, listPackages.defaults, { placeFromId: listPackages.params.placeFromId });
                    listPackages.params._page = listPackages.defaults._page;
                }

                this.triggerDepartureClearPoint = false;

                //functions.setFormData(listPackages.form, listPackages.defaults, false);
     
            });
            $elem.on('select2:clear', function (e, stop) {
                this.triggerDepartureClearPoint = true;
            });
        });

        if(! this.isHome) {
            if (! this.params.destination) this.params.destination = 6;
            //this.getParams();
            functions.setFormData(this.form, this.params);
            if(this.filter) {
                functions.setFormData(this.filter, this.params);
            }

            if($('[name=guests]').val()) {
                this.params.guests = $('[name=guests]').val();
            }
            this.find(this.params);
        } else {

            functions.setFormData(this.form, $.extend(this.defaults, {destination: 6}));
        }

        list.setBtnSearchValue(this.params);

        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            this.isHome = $target.attr('data-ishome') || this.isHome;

            if(this.isHome) {
                this.defaults.dynamicPackage = $target.attr('data-dynamicpackage');
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.countryId = this.params.destination = $target.attr('data-countryid');
                this.defaults.countryId = this.defaults.destination = null;
                this.params.perPage = $target.attr('data-perpage') || this.defaults.perPage;
                this.params = $.extend({}, this.defaults, functions.getFormData($target));
            } else {
                this.getParams();
                this.params = $.extend(this.params, functions.getFormData($target));
                
                if(this.defaults.dynamicPackage && this.params.dateFrom && this.params.dateTo) {
                    this.params.arrivalDateFrom = this.params.dateFrom;
                    this.params.arrivalDateTo = this.params.dateTo;
                    this.params.hasArrival = 3;
                } else {
                    this.params.arrivalDateFrom = this.params.arrivalDateTo = null;
                }

                this.params.time = '';

                if(! this.params.dates && ! this.defaults.dynamicPackage) {
                    this.params.dateFrom = this.params.dateTo = null;
                }
            }
            this.params._page = this.defaults._page;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.objectTypeId = $target.attr('data-objecttypeid');
                this.params.tagCategoryId = $target.attr('data-tagcategoryid');
                this.params.tagCategoryIds = $target.attr('data-tagcategoryids');
                this.params.hasDiscount = $target.attr('data-hasdiscount');

                this.params.tagCategoryIds = this.params.tagCategoryIds ? this.params.tagCategoryIds : this.params.tagCategoryId;
                
                this.params = functions.cleanParams(this.params, this.defaults);
                location = $target.attr('action') + '#' + $.param(this.params);
            } else {
                functions.setUrlData(this.params, true, true, this.defaults);

                functions.isMobile() && $('#modalSearchPackages').modal('hide');
            }

        });

        if ( this.isHome ) {
            return;
        }

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            this.params.destination = '';

            const $form = $(e.currentTarget).parents('.search-form');
            const form = $form[0];

            $(form.destination).val('').trigger('change');
        });

        if(functions.isMobile()) {
            this.$filter.on('submit', e => {
                const $target = $(e.currentTarget);
                e.preventDefault();
    
                if ( this.stopChangeEvents ) {
                    return;
                }
                
                this.params = $.extend(this.params, this.filterParams, functions.getFormData($target));
                this.params._page = this.defaults._page;
                functions.setUrlData(this.params, true, false, this.defaults);
            });
        } else {
            this.$filter.on('change', e => {
                const $target = $(e.currentTarget);
                e.preventDefault();
    
                if ( this.stopChangeEvents ) {
                    return;
                }
                
                this.params = $.extend(this.params, this.filterParams, functions.getFormData($target));
                this.params._page = this.defaults._page;
                functions.setUrlData(this.params, true, false, this.defaults);
            });

            this.$filter.on('submit', e => {
                e.preventDefault();
            });
        }

        $('.btn-clear-filters').on('click', e => {
            e.preventDefault();

            this.getParams();
            this.params = $.extend(this.params, this.defaults);
            this.params._page = this.defaults._page;

            this.stopChangeEvents = true;
            functions.setUrlData(this.params, true, false, this.defaults);
            functions.setFormData(this.filter, this.defaults);
            functions.setFormData(this.form, this.defaults);
            this.stopChangeEvents = false;
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.stopChangeEvents = true;

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;

            list.setBtnSearchValue(this.params);
        });

    },
    getParams() {
        this.params = list.getParams(this.params, this.defaults, this.filterParams);
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        } else if(! this.defaults.dynamicPackage) {
            this.params.dateFrom = this.params.dateTo = null;
        }

        this.params.guests = this.params.guests.startsWith('0') ? null : this.params.guests;

        this.params.arrivalDateFrom = this.defaults.dynamicPackage && this.params.dateFrom ? this.params.dateFrom : null;
        //this.params.arrivalDateFrom = this.defaults.dynamicPackage && this.params.arrivalDateFrom ? this.params.arrivalDateFrom : null;
        this.params.arrivalDateTo = this.defaults.dynamicPackage && this.params.dateTo ? this.params.dateTo : null;
        this.params.hasArrival = this.defaults.dynamicPackage && (this.params.arrivalDateFrom || this.params.dateFrom) ? 3 : null;

        this.setFiltersCount();
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    setFiltersCount() {
        let filtersCount = 0;
        $.map(this.params, (val, name) => {
            this.mainFields.indexOf(name) === -1 && val && val !== this.defaults[name] && (filtersCount++);
        });

        this.$filtersCount.length && this.$filtersCount.html(filtersCount || '');
    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true, false, this.defaults);
    },
    gdsCalculation(url, objectIds, id, chId) {
        $.post(url, {
            objectIds: objectIds,
            guests: this.params.guests,
            dateFrom: this.params.dateFrom,
            dateTo: this.params.dateTo,
            aDateFrom: this.params.aDateFrom,
            aDateTo: this.params.aDateTo,
            chId: chId,
            dynamicPackage: this.params.dynamicPackage
        }).always(response => {

            response = typeof response === "object" ? response : (response ? JSON.parse(response) : null);

            if (response && response.status) {

                objectIds.forEach(objectId => {
                    let $object = $('[data-'+id+'="'+objectId+'"]');
                    let objectData = response.data[objectId];

                    let hasPrice = !!objectData;
                    $object.find('.price-block').toggleClass('d-none', ! hasPrice);
                    $object.find('.card-not-available').toggleClass('d-none', hasPrice);
                    $object.find('.spinner').addClass('d-none');

                    let total = 0.00;
                    if (typeof objectData === "object") {
                        total = objectData.total;
                    } else {
                        total = objectData;
                    }

                    hasPrice && $object.find('.total').html(functions.formatMoney(total, 0, '.', ','));
                });
            } else {
                objectIds.forEach(objectId => {
                    let $object = $('[data-'+id+'="'+objectId+'"]');
                    $object.find('.price-block').addClass('d-none');
                    $object.find('.card-not-available').addClass('d-none');
                    $object.find('.card-search-label').removeClass('d-none');
                    $object.find('.total').html('');
                    $object.find('.spinner').addClass('d-none');
                });
            }
        })
    },
    find(params) {
        if(! this.params.dates) {
            //this.params.dateTo = $('input[name="dateTo"]').val();
        }
        list.find(params).then((response) => {
            list.findDone(response);
            // LOZAD
            window.observer.observe();

            let cardSlider = [];
            $('[id^=card-slider]').each((i, elem) => {
                //const length = $(elem).find('.keen-slider__slide').length;
                cardSlider[i] = new Slider('#' + $(elem).attr('id'), {
                    rubberband: false,
                    loop: true,
                    arrows: true,
                    slidesPerView: 1,
                    spacing: 0,
                    pager: false,
                    drag: functions.isMobile(),
                });
            });

            $('.departure').on('click', e => {
                e.preventDefault();

                const $target = $(e.currentTarget);
                let href = $target.attr('data-href');
                href = href.split('#')[0];

                const dateFrom = $target.attr('data-datefrom');
                const dateTo = $target.attr('data-dateto');

                href += '#dateFrom=' + dateFrom + '&dateTo=' + dateTo;
                //location = href; 
                window.open(href, '_blank');
            });

            ! functions.isMobile() && $('.select2[name="sortBy"]').each((i, elem) => {
                elem._select2 = new Select2(elem);
            });

            // register paginate        
            $('[data-page]').on('click', e => {
                e.preventDefault();
                this.paginate(+$(e.currentTarget).attr('data-page'));
            });

            this.$sortBy = $('[name="sortBy"]');
            this.sortBy = this.$sortBy.length ? this.$sortBy[0] : null;

            if(this.sortBy && this.params.sortBy) {
                this.$sortBy.each((index, elem) => {
                    if(elem.type === 'checkbox') {
                        elem.checked = elem.value === this.params.sortBy;
                    } else if(elem.type === 'select-one') {
                        $(elem).val(this.params.sortBy).trigger('change');
                    }
                });
            }

            this.$sortBy.on('change', e => {
                let data = functions.getFormData($(e.currentTarget));
                data.sortBy = data.sortBy ? data.sortBy : '11:DESC';
                this.params = $.extend(this.params, this.getParams(), data);
                functions.setUrlData(this.params, true, true, this.defaults);
            });

            if ((this.$listItems.find('[data-chtg]').length) &&
                this.params.guests &&
                this.params.dateFrom &&
                this.params.dateTo)
            {

                let objectIdsTG = [];
                this.$listItems.find('[data-chtg]').each((index, item) => {
                    if ($(item).attr('data-chtg')) {
                        objectIdsTG.push($(item).attr('data-chtg'));
                    }
                });

                let $elem = $('[data-chtg]');

                $elem.find('.spinner').removeClass('d-none');
                $elem.find('.card-search-label').addClass('d-none');
                $elem.find('.price-block').addClass('d-none');
                $elem.find('.total').html('');

                if (objectIdsTG.length) {
                    listPackages.gdsCalculation('/services/gds_list_calculation/', objectIdsTG, 'chtg', 50);
                }
            }

        });
    },
    getDeparturePoints(dynamicPackage) {
        return $.post('/services/departure_points/', { dynamicPackage: dynamicPackage });
    },
    getDepartures(departurePoints) {

        let departures = [{key:-1, text: ''}];

        Object.values(departurePoints).length && departurePoints.forEach((item, key) => {
            departures[key] = { id: item.id };
            departures[key].text = item.name;
            departures[key].data = item;
        });

        return departures;
    },
    initDeparturedSelect($elem, departures) {
        $elem.select2(
            {
                placeholder: $elem.attr('data-placeholder'),
                data: departures,
                //minimumResultsForSearch: -1,
            }
        );

        $elem.attr('data-loaded', true);
        $elem.find('option[value="loader"]').remove();

        let departure = departures.filter(item => {
            return item.id == listPackages.params.placeFromId;
        })[0];
        $elem[0].departure = departure;
    },
};